import { m } from 'framer-motion';
import { forwardRef } from 'react';

// Floating Action Button com animacao framer-motion. Substitui MUI Fab. A cor
// pode ser 'primary', 'secondary', 'default', 'inherit' (passa para button HTML)
// ou nome de token (usa --gps-* diretamente via style inline).

const FabButtonAnimate = forwardRef(({ color = 'primary', size = 'large', children, sx, sxWrap, ...other }, ref) => {
  // MUI colors que sao mapeadas direto para HTML
  const isStandardColor = ['default', 'inherit', 'primary', 'secondary'].includes(color);

  if (isStandardColor) {
    return (
      <AnimateWrap size={size} sxWrap={sxWrap}>
        <button
          ref={ref}
          type="button"
          className={`rounded-full border-none text-white flex items-center justify-center transition-all
            ${size === 'small' ? 'w-10 h-10' : size === 'medium' ? 'w-14 h-14' : 'w-16 h-16'}
            ${color === 'primary' ? 'bg-primary hover:opacity-90' : 'bg-secondary hover:opacity-90'}
            disabled:opacity-50 disabled:cursor-not-allowed`}
          {...other}
        >
          {children}
        </button>
      </AnimateWrap>
    );
  }

  // Cores customizadas (possivelmente tokens CSS)
  return (
    <AnimateWrap size={size} sxWrap={sxWrap}>
      <button
        ref={ref}
        type="button"
        className={`rounded-full border-none flex items-center justify-center transition-all
          ${size === 'small' ? 'w-10 h-10' : size === 'medium' ? 'w-14 h-14' : 'w-16 h-16'}
          disabled:opacity-50 disabled:cursor-not-allowed`}
        style={{
          backgroundColor: `var(--gps-${color})`,
          color: 'white',
        }}
        {...other}
      >
        {children}
      </button>
    </AnimateWrap>
  );
});

FabButtonAnimate.displayName = 'FabButtonAnimate';

export default FabButtonAnimate;

// Variacoes de escala por tamanho, aplicadas em hover/tap via framer-motion.
const varSmall = {
  hover: { scale: 1.07 },
  tap: { scale: 0.97 },
};

const varMedium = {
  hover: { scale: 1.06 },
  tap: { scale: 0.98 },
};

const varLarge = {
  hover: { scale: 1.05 },
  tap: { scale: 0.99 },
};

function AnimateWrap({ size, children, sxWrap }) {
  const isSmall = size === 'small';
  const isLarge = size === 'large';

  return (
    <m.div
      whileTap="tap"
      whileHover="hover"
      variants={(isSmall && varSmall) || (isLarge && varLarge) || varMedium}
      className="inline-flex"
    >
      {children}
    </m.div>
  );
}
